export const reservationList = [
  {
    id: "b1334538-0d13-4b3e-a41d-4c486be100a7",
    firstName: "John",
    lastName: "Doe",
    email: "john01@gmail.com",
    seatNumber: "L3",
    bookingDate: "2024-01-19T06:20:42.273Z",
  },
  {
    id: "8b456352-6fb5-4e18-80c8-5c2565bb29d1",
    firstName: "Alice",
    lastName: "Smith",
    email: "alice.smith@example.com",
    seatNumber: "L13",
    bookingDate: "2024-01-19T08:45:30.123Z",
  },
  {
    id: "f5a78cb2-90ad-4a98-9d0e-55d8f8db9d43",
    firstName: "Bob",
    lastName: "Johnson",
    email: "bob.j@example.com",
    seatNumber: "U5",
    bookingDate: "2024-01-19T10:15:18.567Z",
  },
  {
    id: "e8db32e1-6ac6-494c-8f31-cc29d8c7f5b0",
    firstName: "Emily",
    lastName: "Brown",
    email: "emily.brown@example.com",
    seatNumber: "U10",
    bookingDate: "2024-01-19T12:40:55.789Z",
  },
];
